export const UpcomingConcerts = [
    {
        id: '91',
        date: '26 – 27 sept 2026',
        place: 'Wrocław Opera',
        title: "Playing with Monsters",
        subtitle: 'Mateusz Ryczek',
        link: "https://www.opera.wroclaw.pl/en/playing-with-monsters",
        // cast: [`Agnieszka Adamczak- The Girl Rose`, `Aleksandra Opała - Lila (Rose’s sister)`, `Łukasz Rosiak - Dad`, `Sebastian Rutkowski - Weles/ Chors`, `Nicola Jamrozik - A monster from Slavic folklore`, `Katarzyna Toboła - A monster from Slavic folklore`, `Urszula Czupryńska - A monster from Slavic folklore`],
        orchestra: 'Ballet and Orchestra of Wrocław Opera',
        director: 'Marta Streker',
        music: 'Mateusz Ryczek',
        choreography: '',
        conductor: 'Rafał Karczmarczyk',
        scenography: '',
        premiere: 'PREMIERE',
        assistant: ''
    },
    {
        id: '92',
        date: '15 oct 2026',
        place: 'Orchestra Sinfonica Città Metropolitana di Bari',
        title: "Symphonic Concert",
        subtitle: '',
        piece1: '',
        // cast: [`Marcin Kupiński - Bournonville`, 'Mizuno Toma - Caroline', 'Alessandro Ciotta - Pierwszy tancerz', 'Armando Barros - Rybak', 'Daniel Agudo Gallardo - Dyrektor', 'Pablo Martinez Mendez - Artysta śpiewak', 'Sylwia Miazga - Sprzedawca lemoniady', 'Sergi Martinez  Castello - Sprzedawca makaronu', 'Piotr Oleksiak - Ksiądz', 'Lucas Hessel Rafalovich - Muzyk', 'Natalia Augustyniak, Miho Okamura, Maki Sekuzu, Risa Sasaki, Leonie Hansen, Sherly Belliard, Magdalena Kurilec-Malinowska, Nonka Miyamoto - Tancerki', 'Kei Otskua Keisuke Sakai David Oscar Blat Andrzej Malinowski Massimo Colonna Romano Dino Staković - Tancerze', 'Maki Sekuzu Risa Sasaki Leonie Hansen Sherly Belliard David Oscar Blat Keisuke Sakai Miho Okamura Natalia Augustyniak Kei Otsuka - Pas de six i wariacje'],
        orchestra: '',
        soloName: "Arpist Winner of 'I CONCERTI DI ROTA' Competition",
        soloInstrument: 'Harp',
        conductor: 'Rafał Karczmarczyk',
    }, 
    {
        id: '93',
        date: '14 – 21 nov 2026',
        place: 'Wrocław Opera',
        title: "A Midsummer Night's Dream",
        subtitle: 'Felix Mendelssohn',
        link: "https://www.opera.wroclaw.pl/en/sen-nocy-letniej-felix-mendelssohn-bartholdy",
        piece1: '',
        // cast: [`Marcin Kupiński - Bournonville`, 'Mizuno Toma - Caroline', 'Alessandro Ciotta - Pierwszy tancerz', 'Armando Barros - Rybak', 'Daniel Agudo Gallardo - Dyrektor', 'Pablo Martinez Mendez - Artysta śpiewak', 'Sylwia Miazga - Sprzedawca lemoniady', 'Sergi Martinez  Castello - Sprzedawca makaronu', 'Piotr Oleksiak - Ksiądz', 'Lucas Hessel Rafalovich - Muzyk', 'Natalia Augustyniak, Miho Okamura, Maki Sekuzu, Risa Sasaki, Leonie Hansen, Sherly Belliard, Magdalena Kurilec-Malinowska, Nonka Miyamoto - Tancerki', 'Kei Otskua Keisuke Sakai David Oscar Blat Andrzej Malinowski Massimo Colonna Romano Dino Staković - Tancerze', 'Maki Sekuzu Risa Sasaki Leonie Hansen Sherly Belliard David Oscar Blat Keisuke Sakai Miho Okamura Natalia Augustyniak Kei Otsuka - Pas de six i wariacje'],
        orchestra: 'Ballet and Orchestra of Wrocław Opera',
        choreography: 'Anna Hop',
        conductor: 'Rafał Karczmarczyk',
        // costumeDesign: 'Katarzyna Rott',
        // assistantChoreographer: 'Piotr Stańczyk',
        // assistantCostumeDesigner:'Maria Pawlicka',
        // scenography: 'Małgorzata Szabłowska',
        assistant: ''
    },
    {
        id: '93',
        date: "31 dec 2026 – 3 jan 2027",
        place: 'Wrocław Opera',
        title: `New Year's Eve Gala "Finalmente Mozart!"`,
        link: "https://www.opera.wroclaw.pl/en/new-year-s-eve-gala-finalmente-mozart",
        subtitle: '',
        piece1: '',
        // cast: [`Maria Rozynek - Soprano`, `Hanna Sosnowska-Bill - Soprano`, `Aleksandra Opała - Mezzosoprano`, `Paweł Żak - Tenor`, `Tomasz Łykowski - Baritone`, `Tomasz Rudnicki - Bass`, `Sebastian Rutkowski - Bass`, `Jacek Jaskuła - Concert host`, `Aleksander Zuchowicz - Concert host`],
        orchestra: 'Orchestra of Wrocław Opera',
        director: 'Hanna Marasz-Fiugajska',
        conductor: 'Rafał Karczmarczyk',
    }, 
    {
        id: '94',
        date: '19 – 21 feb 2027',
        place: 'Wrocław Opera',
        title: `Triple Bill`,
        subtitle: '',
        link: "https://www.opera.wroclaw.pl/en/triple-bill",
        piece1: '',
        // cast: [`Maria Rozynek - Soprano`, `Hanna Sosnowska-Bill - Soprano`, `Aleksandra Opała - Mezzosoprano`, `Paweł Żak - Tenor`, `Tomasz Łykowski - Baritone`, `Tomasz Rudnicki - Bass`, `Sebastian Rutkowski - Bass`, `Jacek Jaskuła - Concert host`, `Aleksander Zuchowicz - Concert host`],
        orchestra: 'Orchestra of Wrocław Opera',
        choreography: 'Jiří Kylián | Rafael Bonachela',
        conductor: 'Rafał Karczmarczyk',
    }, 
    {
        id: '95',
        date: '17 – 25 apr 2027',
        place: 'Wrocław Opera',
        title: "Frida",
        subtitle: 'Peter Salem',
        link: "https://www.opera.wroclaw.pl/en/frida-peter-salem",
        // cast: [`Carola Minardo | Phoebe Anderssen - Frida Kahlo`, 'Daniel Agudo Gallardo | Łukasz Ożga - Diego Rivera', 'Laura Flügel - Jeleń / The Deer', 'Maki Sekuzu - Ptak / The Bird', 'Shiho Ishizu - Królowa liści / Queen Leaf', 'Armando Barros, Duarte Barros, Alessandro Ciotta, Andrzej Malinowski, Javier Osa - Szkielety męskie / Male Skeletons', 'Dino Staković - Zielona Frida / Green Frida', 'Massimo Colonna Romano - Fioletowa Frida / Purple Frida', 'Kei Otsuka - Jasnoniebieska Frida / Light Blue Frida', 'Riccardo Persico - Czerwona Frida / Red Frida', 'Keisuke Sakai - Żołta Frida / Yellow Frida', 'David Oscar Blat - Turkusowa Frida / Teal Frida', 'Javier Gutierrez Cuervo - Liliowa Frida / Lilac Frida', 'Davide Piccoli - Ciemnoniebieska Frida / Dark Blue Frida', 'Oliver Hornby - Rożowa Frida / Pink Frida', 'Natalia Augustyniak Paula Dzwonik Paulina Grodzńska Leonie Hansen Shantana Hull-Jurkovic Shiho Ishizu Zofia Korpacka Magdalena Kurilec-Malinowska Risa Sasaki Agata Załuska - Szkielety żeńskie / Female Skeletons', 'Maki Sekuzu - Pierwsza kochanka / Mistress One', 'Risa Sasaki - Druga kochanka / Mistress Two', 'Natalia Augustyniak - Trzecia kochanka / Mistress Three', 'Phoebe Anderssen Natalia Augustyniak Paula Dzwonik Paulina Grodzińska Leonie Hansen Shantana Hull-Jurkovic Shiho Ishizu Zofia Korpacka Magdalena Kurilec-Malinowska Risa Sasaki Maki Sekuzu Agata Załuska - Liściaste damy / Leaf Ladies', 'Paula Dzwonik - Wiktoriańska Frida / Victorian Frida', 'Agata Załuska - Strzaskana kolumna Fridy / Frida — The Broken Column', 'Shiho Ishizu - Cristina, siostra Fridy / Cristina, Frida’s sister', 'Dino Staković - Alejandro, przyjaciel Fridy / Alejandro, Frida’s boyfriend', 'Barbara Gorgoń - Młoda Frida / Young Frida' ],
        orchestra: 'Ballet and Orchestra of Wrocław Opera',
        choreography: 'Annabelle Lopez Ochoa',
        conductor: 'Rafał Karczmarczyk',
        scenography: 'Dieuweke van Reij',
        // balletDirector: 'Małgorzata Dzierżon',
        lightingDesign: 'Christopher Ash'
    },
];